// extracted by mini-css-extract-plugin
export default {"icon":"Button_icon__LnzSs","label":"Button_label__BDb3b","gray":"Button_gray__IP02c"};